<template>
  <v-app>
    <NavHeader v-if="isAuthenticated" class="d-print-none" />
    <v-content :class="colorPage">
      <router-view></router-view>
    </v-content>
  </v-app>
</template>

<script>
import { EventBus } from "./main.js";
import NavHeader from "./components/NavCMP";
import { mapGetters } from "vuex";
// import { logInReq } from "@/axiosfiles/axios-outh";
import axios from "axios";

export default {
  name: "App",
  components: {
    NavHeader,
  },
  data() {
    return {
      colorPage: "grey lighten-3",
    };
  },
  computed: {
    ...mapGetters(["isAuthenticated"]),
  },
  methods: {
    loadData() {
      this.$store.dispatch("SelectAll", {
        url: "/cashTypes",
        MutName: "SaveCashTypes",
      });
    },
    async pagTitle() {
      let titlePage = await localStorage.getItem("comp");
      document.title = titlePage || "Maashka";
      axios
        .post("/api/login/ci")
        .then(result => {
          // console.log(result);
          if (result.data) {
            let title = result.data;
            localStorage.setItem("comp", title.slice(0, title.indexOf(".")));
            document.title = title.slice(0, title.indexOf("."));
          } else document.title = "Maashka";
        })
        .catch(() => {
          document.title = "Maashka";
        });
    },
  },
  mounted() {
    EventBus.$on("PrintEvent", val => {
      if (val != true) this.colorPage = "white";
      else this.colorPage = "grey lighten-3";
      // console.log(value);
    });
    if (this.isAuthenticated) this.loadData();
    this.pagTitle();
  },
  created() {
    if (this.isAuthenticated) this.loadData();

    // console.log(process.env.NODE_ENV);
  },
  onIdle() {
    if (process.env.NODE_ENV == "production") this.$store.commit("OnLogout");
  },
  // onActive() {
  //   this.message = "Active";
  //   console.log(123);
  // }
};
</script>
